import { ArrowLeft } from "lucide-react";

interface ProgramHeaderProps {
  programName: string;
  code: string;
  onBackClick: () => void;
}

export default function ProgramHeader({
  programName,
  code,
  onBackClick,
}: ProgramHeaderProps) {
  return (
    <div className="flex items-center gap-3 py-3">
      <button
        onClick={onBackClick}
        className="size-8 rounded-full flex items-center justify-center hover:bg-[#f0f2f1] transition-colors"
      >
        <ArrowLeft className="size-4 text-[#374741]" />
      </button>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold text-[#051912] truncate">
          {programName}
        </p>
        {code && <p className="text-[11px] text-[#697571] truncate">{code}</p>}
      </div>
    </div>
  );
}
